import React from "react";
import { Link, Navigate, useLocation, useParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import { getCommercialCapabilities } from "../pageInside/Rolle";
import { elakayAutoText as text } from "../pageInside/dataElakay";
import { isAuthenticated } from "./index";
import { PROVIDER_ROUTES, providerRedirectState } from "../dropshippingInterne/providerWorkspace";
import "../dropshippingInterne/center/center.css";
import "../dropshippingInterne/center/providerCenter.css";

// Provider storefronts and Provider product pages are a B2B space: Sellers and the Combined Sell
// Center roles browse them (capability, same as before), everybody else gets an explicit
// "restricted" page instead of the storefront -- a pasted/shared/bookmarked link never renders
// Provider data for a Royalty / User / guest. The backend is the real barrier: every
// /internal-dropshipping route answers 403 to those roles (requireCatalogAccess).
export const RestrictedStorefront = ({ infoSource, reason }) => {
  const location = useLocation();
  const provider = reason === "provider";
  return (
    <Layout infoSource={infoSource} titleElakay="providerProducerIn" SliderPunShow={false} loading={false} outOffPage={false} {...infoSource?.allSettings?.layout} showFooter={true}>
      <section className="pvc-restricted" role="alert" aria-labelledby="pvc-restricted-title">
        <i className="fas fa-lock" aria-hidden="true" />
        <h1 id="pvc-restricted-title">{text("h_pvc_restricted_title", "This storefront is available to authorized Elakay business partners.")}</h1>
        <p>{provider
          ? text("h_pvc_restricted_provider", "Provider storefronts are browsed from a Seller account. Your own storefront and tools are in Provider Center.")
          : reason === "guest"
            ? text("h_pvc_restricted_guest", "Sign in with a Seller or professional account to continue.")
            : text("h_pvc_restricted_user", "Provider products and wholesale offers are reserved for Elakay Sellers. Products from Providers remain available to you in Sellers' shops.")}</p>
        <div className="pvc-actions">
          {provider && <Link className="ctr__btn ctr__btn--primary" to={PROVIDER_ROUTES.dashboard}>{text("h_pvc_title", "Provider Center")}</Link>}
          {reason === "guest" && <Link className="ctr__btn ctr__btn--primary" to="/signin" state={{ from: location }}>{text("h_pvc_signin", "Sign in")}</Link>}
          {reason === "user" && <Link className="ctr__btn ctr__btn--primary" to="/your-step">{text("h_pvc_become_seller", "Become a Seller")}</Link>}
          <Link className="ctr__btn" to="/">{text("h_pvc_home", "Back to Elakay")}</Link>
        </div>
      </section>
    </Layout>
  );
};

// `ownStorefront`: what a Provider opening its OWN storefront gets -- "redirect" (the Seller-side
// catalogue routes: its storefront management page) or "render" (the /provider-shop website: the
// exact page Sellers see, which is how "Open as Sellers see it" works).
export const ProviderStorefrontRoute = ({ infoSource, capability = "canBrowseProviders", ownStorefront = "redirect", children }) => {
  const location = useLocation();
  const params = useParams();
  const caps = getCommercialCapabilities(infoSource);
  if (caps[capability]) return children;
  const session = isAuthenticated();
  if (!session?.token) return <RestrictedStorefront infoSource={infoSource} reason="guest" />;
  if (caps.canAccessProviderCenter) {
    // A Provider opening a link to its OWN storefront lands on its storefront management page.
    const providerId = params.providerId || new URLSearchParams(location.search).get("providerId");
    const ownId = infoSource?.userInfo?._id || session?.user?._id;
    if (providerId && ownId && String(providerId) === String(ownId)) {
      if (ownStorefront === "render") return children;
      return <Navigate to={PROVIDER_ROUTES.myShop} replace state={providerRedirectState(text("h_pvc_notice_own_shop", "This is your storefront as Sellers see it — manage it here."))} />;
    }
    return <RestrictedStorefront infoSource={infoSource} reason="provider" />;
  }
  return <RestrictedStorefront infoSource={infoSource} reason="user" />;
};
